import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//

import { getToken } from '@/utils/auth';
export default {
  data: function data() {
    return {
      visible: false,
      iframeLoading: false,
      todoTitle: '查看待办',
      todoUrl: ''
    };
  },
  mounted: function mounted() {
    var _this = this;
    window.addEventListener('message', function (event) {
      // console.log(event, 'message')
      var data = event.data;
      var isCloseModal = /CLOSEMODAL/;
      var isTodoTask = /todoTask/;
      if (data && typeof data === 'string' && isCloseModal.test(data) && isTodoTask.test(data)) {
        // this.$message({ type: 'success', message: '待办处理成功!' })
        _this.$emit('searchForm');
        _this.visible = false;
      }
    });
  },
  methods: {
    show: function show(item) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.iframeLoading = true;
                _this2.visible = true;
                _context.next = 4;
                return _this2.$nextTick();
              case 4:
                _this2.initIframe(item);
                // eslint-disable-next-line no-return-assign
                _context.next = 7;
                return new Promise(function (resolve) {
                  return _this2.close = resolve;
                });
              case 7:
                _this2.visible = false;
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    initIframe: function initIframe(item) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var todoTitle, url, taskurl, todoUrl, iframe;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                try {
                  todoTitle = item.todoTitle, url = item.url;
                  taskurl = url;
                  if (item.systemId === 'LC_RMS') {
                    if (url.indexOf('/#/') > 0) {
                      taskurl = "".concat(url.split('/#')[0], "/taskManage").concat(url.split('/#')[1], "&taskId=").concat(item.id);
                    } else {
                      taskurl = "".concat(url, "&taskId=").concat(item.id);
                    }
                  }
                  // url = formlistofurl[0] + formlistofurl[1]
                  todoUrl = "".concat(taskurl, "&access_toke=").concat(getToken()); // const todoUrl = `${url.split("/#")[0]}/taskManage${url.split("/#")[1]}&taskId=${item.id}&access_toke=${getToken()}`
                  Object.assign(_this3, {
                    todoTitle: todoTitle,
                    todoUrl: todoUrl
                  });
                  iframe = _this3.$refs.iframe; // iframe.contentWindow.location.reload(true)
                  if (iframe.attachEvent) {
                    iframe.attachEvent('onload', function () {
                      _this3.iframeLoading = false;
                    });
                  } else {
                    iframe.onload = function () {
                      _this3.iframeLoading = false;
                    };
                  }
                } catch (error) {
                  // this.$message({ message: error || '加载出错', type: 'warning' })
                  _this3.iframeLoading = false;
                }
              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    dialogBeforeClose: function dialogBeforeClose() {
      this.close();
      this.iframeLoading = false;
    }
  }
};